module.exports = __webpack_public_path__ + "img/house-loading-1.e3d88c2f.gif";